import PropTypes from 'prop-types'

export const ContractPropType = PropTypes.shape({
  uuid: PropTypes.string,
})
